/*
export const API_BASE_URL = /!*"http://localhost:8080/apis"*!/`${process.env.REACT_APP_AUTH_API_URL}/apis`;
export const UI_FLOW_URL =  /!*"http://localhost:3000/welcome"*!/`${process.env.REACT_APP_AUTH_UI_URL}/welcome`;
*/
export const ACCESS_TOKEN = "accessToken";
export const LOGIN = "login";

export const NAME_MIN_LENGTH = 4;
export const NAME_MAX_LENGTH = 40;

export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 15;

export const EMAIL_MAX_LENGTH = 40;

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 20;

export const INVALID_DOMAINS = ["@gmail.", "@yahoo.", "@hotmail.", "@live.", "@aol.", "@outlook."];

export const VALIDATE_COMPANY_EMAIL = false;
